<template>
  <div v-loading="loading"
       class="dashboard-area"
       style="position: relative;">
<!--    <div v-gutter="8" class="filter-group">-->
<!--      <gj-radio-group-->
<!--          v-if="tabName === 'saleHot' || tabName === 'return'"-->
<!--          v-model="filter.dateType"-->
<!--          :options="option.dateType">-->
<!--      </gj-radio-group>-->
<!--      <gj-select-->
<!--          v-model="filter.type"-->
<!--          :options="option.type"-->
<!--          width="90px"-->
<!--          :clearable="false"-->
<!--      ></gj-select>-->
<!--    </div>-->
    <el-tabs v-model="tabName">

      <div class="flex justify-between align-center filter-box">
        <div>
          <gj-radio-group
              v-if="tabName!=='performanceContribution'"
              v-model="filter.type"
              :options="option.type">
          </gj-radio-group>
        </div>


        <div>
          <span class="size12 color666" style="margin-right: 16px;">仅30天内有销量且在售商品参与榜单计算</span>

          <gj-date-picker
              v-model="filter.month"
              :clearable="false"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              width="100px"
          ></gj-date-picker>
        </div>
      </div>

<!--      贡献榜-->
      <el-tab-pane name="contribution">
        <template #label>
<!--          <span class="">-->
            贡献榜
            <gj-help font-size="16px">
              排序字段：销售毛利倒序排列<br>
              说明：此榜单根据销售毛利从高到低排列，表明商品整体的贡献情况
            </gj-help>
<!--          </span>-->
        </template>
        <app-dashboard-contribution-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-contribution-rank>
      </el-tab-pane>

<!--      新晋人气榜-->
      <el-tab-pane name="newPopularity" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            新晋人气榜
            <gj-help font-size="16px">
              排序字段：涨幅倒序排列<br>
              说明：由于人气榜是当月与上月相比，会存在时间差的问题，要根据当前天的日期定位本月天数，环比倒推上个月同样的天数
            </gj-help>
<!--          </span>-->
        </template>
        <app-dashboard-popularity-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-popularity-rank>
      </el-tab-pane>

<!--      负豪榜-->
      <el-tab-pane name="negativeMogul" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            负豪榜
            <gj-help font-size="16px">
              排序字段：销售毛利率正序排列<br>
              说明：此榜单根据销售毛利率从低到高排列，表明商品整体的影响
            </gj-help>
<!--          </span>-->
        </template>
        <app-dashboard-negative-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-negative-rank>
      </el-tab-pane>

<!--      热销榜-->
      <el-tab-pane name="saleHot" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            热销榜
<!--          </span>-->
        </template>
        <app-dashboard-sale-hot-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-sale-hot-rank>
      </el-tab-pane>

<!--      滞销榜-->
      <el-tab-pane name="saleLow" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            滞销榜
<!--            <gj-help font-size="16px">-->
<!--              该模块数据为最新数据，不根据时间筛选统计-->
<!--            </gj-help>-->
<!--          </span>-->
        </template>
        <app-dashboard-sale-low-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-sale-low-rank>
      </el-tab-pane>

<!--      退款榜-->
      <el-tab-pane name="return" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            退款榜
<!--          </span>-->
        </template>
        <app-dashboard-return-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-return-rank>
      </el-tab-pane>

<!--      缺货榜-->
      <el-tab-pane name="storageLow" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            缺货榜
<!--            <gj-help font-size="16px">-->
<!--              该模块数据为最新数据，不根据实际筛选统计，按可售天数进行排名-->
<!--            </gj-help>-->
<!--          </span>-->
        </template>
        <app-dashboard-storage-low-rank
            :month="filter.month"
            :type="filter.type"
            :tabName="tabName"
        ></app-dashboard-storage-low-rank>
      </el-tab-pane>

<!--      业绩贡献榜-->
      <el-tab-pane name="performanceContribution" v-if="isMeaningful(userInfo)&&(userInfo.type==='accountType'||userInfo.roleName.indexOf('平台管理员')>-1)" lazy>
        <template #label>
<!--          <span class="dashboard-area&#45;&#45;title">-->
            业绩贡献榜
            <gj-help font-size="16px">
              排序字段：销售毛利倒序排列<br>
              说明：此榜单根据销售毛利从高到低排列，表明对应商品负责人的整体贡献情况
            </gj-help>
<!--          </span>-->
        </template>
        <app-dashboard-performance-rank
            :month="filter.month"
            :tabName="tabName"
        ></app-dashboard-performance-rank>
      </el-tab-pane>

    </el-tabs>
    <app-mask :top="'90px'"></app-mask>
  </div>
</template>

<script>
  import AppDashboardContributionRank from "./components/dashboard-contribution-rank";// 贡献榜
  import AppDashboardPopularityRank from "./components/dashboard-popularity-rank";// 新晋人气榜
  import AppDashboardNegativeRank from "./components/dashboard-negative-rank";// 负豪榜
  import AppDashboardSaleHotRank from "./components/dashboard-sale-hot-rank";// 热销榜
  import AppDashboardSaleLowRank from "./components/dashboard-sale-low-rank";// 滞销榜
  import AppDashboardReturnRank from "./components/dashboard-return-rank";// 退款榜
  import AppDashboardStorageLowRank from "./components/dashboard-storage-low-rank";// 缺货榜
  import AppDashboardPerformanceRank from "./components/dashboard-performance-rank";// 业绩贡献榜
  import {convertToMonth} from "@/utils/date.util";
  import AppMask from "@/views/modules/home/components/mask/mask";
  import {userInfoMixIn, isMeaningfulMixin} from "@/minxins";
  import {mapGetters} from "vuex";
  export default {
    name: "app-dashboard-rank",
    mixins: [isMeaningfulMixin],
    components: {
      AppDashboardContributionRank,
      AppDashboardPopularityRank,
      AppDashboardNegativeRank,
      AppDashboardSaleHotRank,
      AppDashboardSaleLowRank,
      AppDashboardReturnRank,
      AppDashboardStorageLowRank,
      AppDashboardPerformanceRank,
      AppMask
    },
    data() {
      return {
        loading: false,
        filter: {
          type: 'asin',
          dateType: 'custom',
          month: convertToMonth(new Date())
        },
        option: {
          type: [
            {id: 'asin', text: '子ASIN'},
            {id: 'variationAsin', text: '父ASIN'},
            {id: 'msku', text: 'MSKU'},
          ],
          dateType: [
            {id: 'today', text: '今日'},
            {id: 'yesterday', text: '昨日'},
            {id: 'custom', text: '自定义'},
          ]
        },
        tabName: 'contribution',
      }
    },
    computed: {
      // 使用对象展开运算符将 getter 混入 computed 对象中
      ...mapGetters([
        'userInfo'
      ])
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";

  /deep/ .el-radio-button--small .el-radio-button__inner{
    font-size: 12px;
  }
  /deep/ .el-tabs__item {
    font-weight: 600;
    height: 30px;
    line-height: 30px;
    //margin-bottom: 3px;
  }
  @media (max-width: 1366px) {
    /deep/ .el-tabs__item {
      padding: 0 10px;
    }
  }
  .filter-group {
    position: absolute;
    z-index: 99;
    right: 16px;
    top: 12px;
  }
  /deep/ .el-tabs__header{
    margin-bottom: 0;
  }
  /deep/.panel-time {
    margin:0 0 8px 0 !important;
  }
  .dashboard-area{
    padding-top: 6px;
  }
  .filter-box{
    height: 56px;
  }

  /deep/ .vxe-cell--tree-node{
    display: flex;
    align-items: center;
    //justify-content: start;
    .vxe-tree-cell{
      padding-left: 0;
    }
    .vxe-tree--btn-wrapper{
      margin-right: 6px;
      transform:none;
      position: relative;
    }
  }
</style>
